import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useOrderList(params) {
  return useSWR(
    !!params && params?.warehouse
      ? {
          path: `/api/v1/orders`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useOrderList;
